<app-page-header [isCurveGray]="true" header="{{language.searchpage1}} {{ search }}" backgroundPath="assets/images/lead/default.png">
</app-page-header>

<!-- กองทุน -->
<section class="investment--container" *ngIf="checkFund">
    <div class="container">
        <header class="heading mt-5">
            <h1 class="topic-title" style="font-size: 30px;"> {{language.searchpage2}} </h1>
        </header>
    </div>
    <div class="container" style="padding-top: 30px;  border-bottom: #eee solid 1px;">
        <div class="row">
            <div *ngFor="let item of FundList" class="col-lg-3 grid-fund-responsive">
                <div class="card -fund">
                    <div class="card-body p-0">
                        <span *ngIf="item.cms_flag_recommend == 'y' " class="icon icon-star"></span>
                        <app-favorite-button [fundid]="item.fundId" [curr]="item.currency" [inCard]="true">
                        </app-favorite-button>
                        <a [routerLink]="['/fund/detail/',item.fundId,item.currency]" class="show-block">
                            <header>
                                <h1 class="h4 topic-title">{{item.fundCode}}</h1>
                                <div *ngIf="flag == 'th'; else elsefundName">
                                    <p class="name">{{item.fundNameTh}}</p>
                                </div>
                                <ng-template #elsefundName>
                                    <p class="name">{{item.fundNameEn}}</p>
                                </ng-template>
                            </header>
                            <section class="card-value">
                                <ul class="list list-inline list-unstyled">
                                    <li>
                                        <span class="group-value">
                                            <em>{{language.searchpage3}} </em>
                                            <span class="number">{{fixFloatDigit(item.navPublish1)}}</span>
                                            <span class="{{isPositive(item.navDiff) ? 'up' : 'down'}}">
                                                <i class="fas fa-caret-{{caretStatus}}"></i>
                                                <span>{{fixFloatDigit(showOnlyValue(item.navDiff))}}
                                                    <small>({{fixFloatDigit(showOnlyValue(item.navDiffPercent))}}%)</small>
                                                </span>
                                            </span>
                                        </span>
                                    </li>
                                    <li>
                                        <span class="group-price"
                                            *ngIf="!(item.fundTypeId == '16' || item.fundTypeId == '15')">
                                            <span>
                                                <em>{{language.fundcardtitle2}}</em>
                                                <p *ngIf="item.navSub != 0; else isZeroNAVSub">
                                                    {{fixFloatDigit(item.navSub)}}</p>
                                                <ng-template #isZeroNAVSub>
                                                    <p>-</p>
                                                </ng-template>
                                            </span>
                                            <span>
                                                <em>{{language.fundcardtitle3}}</em>
                                                <p *ngIf="item.navRed != 0; else isZeroNAVRed">
                                                    {{fixFloatDigit(item.navRed)}}</p>
                                                <ng-template #isZeroNAVRed>
                                                    <p>-</p>
                                                </ng-template>
                                            </span>
                                        </span>
                                    </li>
                                </ul>
                                <p class="total">
                                    <span class="text">{{language.fundcardtitle4}}</span>
                                    <span>{{setNumberFormat(item.netAsset) | number : '1.2-2'}}</span>
                                </p>
                                <p class="total" style="margin-top:-10px"
                                    *ngIf="item.fundTypeId == '16' || item.fundTypeId == '15';else nottotal">
                                    <span class="text">{{language.fundcardtitle6}}</span>
                                    <span>{{setNumberFormat(item.totalassets) | number : '1.2-2'}}</span>
                                </p>
                                <ng-template #nottotal>
                                    <p *ngIf="flag == 'th'" class="total" style="margin-top:-10px; height: 24px; ">
                                        <span class="text">  </span>
                                        <span></span>
                                    </p>
                                    <p *ngIf="flag == 'en'" class="total" style="margin-top:-10px; height: 31px; ">
                                        <span class="text">  </span>
                                        <span></span>
                                    </p>
                                </ng-template>
                            </section>
                            <footer>
                                <time>{{language.fundcardtitle5}} {{changeFormatDate(item.fundPriceDate1)}}</time>
                            </footer>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- กองทุน -->

<!-- ข่าวสาร -->
<section class="investment--container" *ngIf="checkNews">
    <div class="container">
        <header class="heading mt-5 mb-2">
            <h1 class="topic-title" style="font-size: 30px;"> {{language.searchpage4}} </h1>
        </header>
    </div>
    <div class="container" style="padding-top: 30px;  border-bottom: #eee solid 1px; border-top: #eee solid 1px;">
        <div *ngIf="flag == 'th'; else elseNewsList">
            <div class="row">
                <div *ngFor="let item of NewsList" class="col-ss-12 col-xs-4 col-sm-4">
                    <section class="card -new " *ngIf="item.tItle != '' ">
                        <div class="thumb view">
                            <a [routerLink]="['/th/News/detail',item.newsid]" class="parent">
                                <span *ngIf="item.news_img_Thum == ''" class="img-photo img-fluid"
                                    style="background-image: url('../../../assets/images/thumb/photo-1.png')"></span>
                                <span *ngIf="item.news_img_Thum != ''" class="img-photo img-fluid"
                                    [style.background-image]="getBackground(item.news_img_Thum)"></span>
                            </a>
                        </div>
                        <div class="info mb-5">
                            <h3 #dot class="h6 topic-title insert-dotdotdot" style="overflow-wrap: break-word;">
                                <a [routerLink]="['/th/News/detail',item.newsid]">{{item.tItle}}</a>
                            </h3>
                            <time>{{date_thai(item.publicDate)}} </time>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
    <ng-template #elseNewsList>
        <div class="row">
            <div *ngFor="let item of NewsList" class="col-ss-12 col-xs-4 col-sm-4">
                <section class="card -new " *ngIf="item.tItle_en != '' ">
                    <div class="thumb view">
                        <a [routerLink]="['/th/News/detail',item.newsid]" class="parent">
                            <span *ngIf="item.news_img_Thum_en == ''" class="img-photo img-fluid"
                                style="background-image: url('../../../assets/images/thumb/photo-1.png')"></span>
                            <span *ngIf="item.news_img_Thum_en != ''" class="img-photo img-fluid"
                                [style.background-image]="getBackground(item.news_img_Thum_en)"></span>
                        </a>
                    </div>
                    <div class="info mb-5">
                        <h3 #dot class="h6 topic-title insert-dotdotdot" style="overflow-wrap: break-word;">
                            <a [routerLink]="['/th/News/detail',item.newsid]">{{item.tItle_en}}</a>
                        </h3>
                        <time>{{item.publicDate | date:'dd MMMM yyyy'}} </time>
                    </div>
                </section>
            </div>
        </div>
    </ng-template>
</section>
<!-- ข่าวสาร -->

<!-- ประกาศ -->
<section class="investment--container" *ngIf="checkAnnounce">
    <div class="container">
        <header class="heading mt-5 mb-2">
            <h1 class="topic-title" style="font-size: 30px;"> {{language.searchpage5}} </h1>
        </header>
    </div>
    <div class="container" style="padding-top: 30px;  border-bottom: #eee solid 1px; border-top: #eee solid 1px;">
        <div *ngIf="flag == 'th'; else elseAnnounceList">
            <div class="row">
                <ul class="list-announce row">
                    <li data-mh="desc-announce" *ngFor="let item of AnnounceList"
                        class="col-12 offset-0 offset-sm-3 offset-lg-0 col-lg-12 mr-3">
                        <span class="date">{{date_thai_dd(item.publicDate)}}</span>
                        <span
                            class="month-year">{{date_thai_mm(item.publicDate)}}<br>{{date_thai_yy(item.publicDate)}}</span>
                        <a *ngIf="item.title !=' '" [routerLink]="['/th/Announce/detail',item.announceid]"
                            class="visible-touch">
                            <p>{{item.title}} </p>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <ng-template #elseAnnounceList>
            <div class="row">
                <ul class="list-announce row">
                    <li data-mh="desc-announce" *ngFor="let item of AnnounceList"
                        class="col-12 offset-0 offset-sm-3 offset-lg-0 col-lg-12 mr-3">
                        <span class="date">{{item.publicDate  | date:'dd'}}</span>
                        <span
                            class="month-year">{{item.publicDate | date:'MMMM'}}<br>{{item.publicDate | date:'yyyy'}}</span>
                        <a *ngIf="item.title_en !=' '" [routerLink]="['/th/Announce/detail',item.announceid]"
                            class="visible-touch">
                            <p>{{item.title_en}} </p>
                        </a>
                    </li>
                </ul>
            </div>

        </ng-template>
    </div>
</section>
<!-- ประกาศ -->

<!-- Earth Update -->
<section class="investment--container" *ngIf="checkEarthUpdate">
    <div class="container">
        <header class="heading mt-5 mb-2">
            <h1 class="topic-title" style="font-size: 30px;"> {{language.searchpage6}} </h1>
        </header>
    </div>
    <div class="container" style="padding-top: 30px;  border-bottom: #eee solid 1px; border-top: #eee solid 1px;">
        <div *ngIf="flag == 'th'; else elseEarthUpdateList">
            <div class="row">
                <ul class="list-announce row">
                    <li data-mh="desc-announce" *ngFor="let item of EarthUpdateList"
                        class="col-12 offset-0 offset-sm-3 offset-lg-0 col-lg-6 mr-3">
                        <span class="date">{{date_thai_dd(item.publicDate)}}</span>
                        <span
                            class="month-year">{{date_thai_mm(item.publicDate)}}<br>{{date_thai_yy(item.publicDate)}}</span>
                        <a *ngIf="item.title !=' '" [routerLink]="['/th/EartUpdate/detail',item.earthupdateid]"
                            class="visible-touch">
                            <p>{{item.title}} </p>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <ng-template #elseEarthUpdateList>
            <div class="row">
                <ul class="list-announce row">
                    <li data-mh="desc-announce" *ngFor="let item of EarthUpdateList"
                        class="col-12 offset-0 offset-sm-3 offset-lg-0 col-lg-6 mr-3">
                        <span class="date">{{item.publicDate | date:'dd'}}</span>
                        <span
                            class="month-year">{{item.publicDate | date:'MMMM'}}<br>{{item.publicDate | date:'yyyy'}}</span>
                        <a *ngIf="item.title_en !=' '" [routerLink]="['/th/EartUpdate/detail',item.earthupdateid]"
                            class="visible-touch">
                            <p>{{item.title_en}} </p>
                        </a>
                    </li>
                </ul>
            </div>

        </ng-template>
    </div>
</section>
<!-- Earth Update -->

<!-- กองทุนแนะนำ -->
<section class="investment--container" *ngIf="checkFundRecom">
    <div class="container">
        <header class="heading mt-5 mb-2">
            <h1 class="topic-title" style="font-size: 30px;"> {{language.searchpage7}} </h1>
        </header>
    </div>
    <div class="container" style="padding-top: 30px;  border-bottom: #eee solid 1px; border-top: #eee solid 1px;">
        <div class="row">
            <div *ngFor="let item of FundRecomList" class="col-ss-12 col-xs-4 col-sm-4">
                <div *ngIf="flag == 'th'; else elseFundRecomList">
                    <section class="card -new " *ngIf="item.title != '' ">
                        <div class="thumb view">
                            <a [routerLink]="['/th/fundrecomm/detail',item.fundRecomid]" class="parent">
                                <span *ngIf="item.fundRecom_img_Thum == ''" class="img-photo img-fluid"
                                    style="background-image: url('../../../assets/images/thumb/photo-1.png')"></span>
                                <span *ngIf="item.fundRecom_img_Thum != ''" class="img-photo img-fluid"
                                    [style.background-image]="getBackground(item.fundRecom_img_Thum)"></span>
                            </a>
                        </div>
                        <div class="info mb-5">
                            <h3 #dot class="h6 topic-title insert-dotdotdot" style="overflow-wrap: break-word;">
                                <a [routerLink]="['/th/fundrecomm/detail',item.fundRecomid]">{{item.title}}</a>
                            </h3>
                            <time>{{date_thai(item.publicDate)}} </time>
                        </div>
                    </section>
                </div>
                <ng-template #elseFundRecomList>
                    <section class="card -new " *ngIf="item.title_en != '' ">
                        <div class="thumb view">
                            <a [routerLink]="['/th/fundrecomm/detail',item.fundRecomid]" class="parent">
                                <span *ngIf="item.fundRecom_img_Thum_en == ''" class="img-photo img-fluid"
                                    style="background-image: url('../../../assets/images/thumb/photo-1.png')"></span>
                                <span *ngIf="item.fundRecom_img_Thum_en != ''" class="img-photo img-fluid"
                                    [style.background-image]="getBackground(item.fundRecom_img_Thum_en)"></span>
                            </a>
                        </div>
                        <div class="info mb-5">
                            <h3 #dot class="h6 topic-title insert-dotdotdot" style="overflow-wrap: break-word;">
                                <a [routerLink]="['/th/fundrecomm/detail',item.fundRecomid]">{{item.title_en}}</a>
                            </h3>
                            <time>{{date_thai(item.publicDate)}} </time>
                        </div>
                    </section>
                </ng-template>
            </div>
        </div>
    </div>
</section>
<!-- กองทุนแนะนำ -->

<!-- โปรโมชั่น -->
<section class="investment--container" *ngIf="checkPromotion">
    <div class="container">
        <header class="heading mt-5 mb-2">
            <h1 class="topic-title" style="font-size: 30px; "> {{language.searchpage8}} </h1>
        </header>
    </div>
    <div class="container" style="padding-top: 30px;  border-bottom: #eee solid 1px; border-top: #eee solid 1px;">
        <div class="row">
            <div *ngFor="let item of PromotionList" class="col-ss-12 col-xs-4 col-sm-4">
                <div *ngIf="flag == 'th'; else elsePromotionList">
                    <section class="card -new " *ngIf="item.title != '' ">
                        <div class="thumb view">
                            <a [routerLink]="['/th/Promotion/detail',item.promotionid]" class="parent">
                                <span *ngIf="item.promotion_img_Thum == ''" class="img-photo img-fluid"
                                    style="background-image: url('../../../assets/images/thumb/photo-1.png')"></span>
                                <span *ngIf="item.promotion_img_Thum != ''" class="img-photo img-fluid"
                                    [style.background-image]="getBackground(item.promotion_img_Thum)"></span>
                            </a>
                        </div>
                        <div class="info mb-5">
                            <h3 #dot class="h6 topic-title insert-dotdotdot" style="overflow-wrap: break-word;">
                                <a [routerLink]="['/th/Promotion/detail',item.promotionid]">{{item.title}}</a>
                            </h3>
                            <time>{{date_thai(item.publicDate)}} </time>
                        </div>
                    </section>
                </div>
                <ng-template #elsePromotionList>
                    <section class="card -new " *ngIf="item.title_en != '' ">
                        <div class="thumb view">
                            <a [routerLink]="['/th/Promotion/detail',item.promotionid]" class="parent">
                                <span *ngIf="item.promotion_img_Thum_en == ''" class="img-photo img-fluid"
                                    style="background-image: url('../../../assets/images/thumb/photo-1.png')"></span>
                                <span *ngIf="item.promotion_img_Thum_en != ''" class="img-photo img-fluid"
                                    [style.background-image]="getBackground(item.promotion_img_Thum_en)"></span>
                            </a>
                        </div>
                        <div class="info mb-5">
                            <h3 #dot class="h6 topic-title insert-dotdotdot" style="overflow-wrap: break-word;">
                                <a [routerLink]="['/th/Promotion/detail',item.promotionid]">{{item.title_en}}</a>
                            </h3>
                            <time>{{date_thai(item.publicDate)}} </time>
                        </div>
                    </section>

                </ng-template>
            </div>
        </div>
    </div>
</section>
<!-- โปรโมชั่น -->

<!-- สิทธิประโยชน์ -->
<section class="investment--container" *ngIf="checkBenefit">
    <div class="container">
        <header class="heading mt-5 mb-2">
            <h1 class="topic-title" style="font-size: 30px; "> {{language.searchpage9}} </h1>
        </header>
    </div>
    <div class="container" style="padding-top: 30px;  border-bottom: #eee solid 1px; border-top: #eee solid 1px;">
        <div class="row">
            <div *ngFor="let item of BenefitList" class="col-ss-12 col-xs-4 col-sm-4">
                <div *ngIf="flag == 'th'; else elseBenefitList">
                    <section class="card -new " *ngIf="item.title != '' ">
                        <div class="thumb view">
                            <a [routerLink]="['/th/Benefit/detail',item.benefitid]" class="parent">
                                <span *ngIf="item.benefit_img_Thum == ''" class="img-photo img-fluid"
                                    style="background-image: url('../../../assets/images/thumb/photo-1.png')"></span>
                                <span *ngIf="item.benefit_img_Thum != ''" class="img-photo img-fluid"
                                    [style.background-image]="getBackground(item.benefit_img_Thum)"></span>
                            </a>
                        </div>
                        <div class="info mb-5">
                            <h3 #dot class="h6 topic-title insert-dotdotdot" style="overflow-wrap: break-word;">
                                <a [routerLink]="['/th/Benefit/detail',item.benefitid]">{{item.title}}</a>
                            </h3>
                            <time>{{date_thai(item.publicDate)}} </time>
                        </div>
                    </section>
                </div>
                <ng-template #elseBenefitList>
                    <section class="card -new " *ngIf="item.title_en != '' ">
                        <div class="thumb view">
                            <a [routerLink]="['/th/Benefit/detail',item.benefitid]" class="parent">
                                <span *ngIf="item.benefit_img_Thum_en == ''" class="img-photo img-fluid"
                                    style="background-image: url('../../../assets/images/thumb/photo-1.png')"></span>
                                <span *ngIf="item.benefit_img_Thum_en != ''" class="img-photo img-fluid"
                                    [style.background-image]="getBackground(item.benefit_img_Thum_en)"></span>
                            </a>
                        </div>
                        <div class="info mb-5">
                            <h3 #dot class="h6 topic-title insert-dotdotdot" style="overflow-wrap: break-word;">
                                <a [routerLink]="['/th/Benefit/detail',item.benefitid]">{{item.title_en}}</a>
                            </h3>
                            <time>{{date_thai(item.publicDate)}} </time>
                        </div>
                    </section>
                </ng-template>
            </div>
        </div>
    </div>
</section>
<!-- สิทธิประโยชน์ -->